import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    padding: 0.5rem;
  }
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 1.5rem;
`;

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const AttachmentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary ?? theme.colors?.gray01};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 600;
`;

export const AttachmentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FileInput = styled.input`
  display: none !important;
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const FileName = styled.span`
  color: ${({ theme }) => theme.colors?.text?.secondary ?? theme.colors?.gray02};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
  }
`;
